import React from "react";
import CommonHeader from "components/Headers/CommonHeader";
import { Container } from "reactstrap";

const TermsConditions = () => {
  return (
    <>
      <CommonHeader />
      <Container className="mt-4 mb-5">
        <h1 className="mb-4">Terms & Conditions</h1>
        <p>Effective Date: [Insert Date]</p>

        <h3>1. Acceptance of Terms</h3>
        <p>
          By creating an account or using CradleAI, you agree to these Terms & Conditions and our Privacy Policy.
        </p>

        <h3>2. Eligibility</h3>
        <p>You must be at least 18 years old to use CradleAI.</p>

        <h3>3. Free Access</h3>
        <p>All users can download and use CradleAI with limited features at no cost.</p>

        <h3>4. Subscription Plans</h3>
        <p>
          CradleAI offers CradleAI+ ($14.99/month) and CradleAIX ($29.99/month) with added features like unlimited likes, advanced filters, premium match scores, and more.
        </p>

        <h3>5. Payment & Auto-Renewal</h3>
        <p>
          Subscriptions renew automatically unless canceled at least 24 hours before the billing cycle ends.
        </p>

        <h3>6. Card Verification</h3>
        <p>
          To reduce fake accounts, we require a $1 card verification for all users. This is not a subscription.
        </p>

        <h3>7. User Conduct</h3>
        <p>
          You agree not to post harmful, offensive, or illegal content, and not to harass other users.
        </p>

        <h3>8. Termination</h3>
        <p>
          We may suspend or terminate accounts violating these terms.
        </p>

        <h3>9. Contact</h3>
        <p>
          For questions about subscriptions or billing: support@CradleAI.com
        </p>
      </Container>
    </>
  );
};

export default TermsConditions;
